import { render } from "./KullanicilarDetayView.vue?vue&type=template&id=3d9df15d"
import script from "./KullanicilarDetayView.vue?vue&type=script&lang=js"
export * from "./KullanicilarDetayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__